import { useContext, useCallback } from 'react'
import axios from '@fs/zion-axios'
import JurisdictionsContext from '../context/JurisdictionsContext'
import JurisdictionsUpdateContext from '../context/JurisdictionsUpdateContext'

export default function useUpdateRussianJurisdiction() {
  const jurisdictions = useContext(JurisdictionsContext)
  const handleChangeJurisdictions = useContext(JurisdictionsUpdateContext)
  return useCallback(
    async (doesApply) => {
      const payload = [
        ...jurisdictions.filter((x) => x.jurisdiction !== 'RUSSIA'),
        { jurisdiction: 'RUSSIA', doesApply },
      ]
      // Always make the call on the relative path. The next call posts PII to an ident
      // subdomain that Russian-DL does not front; this relative call routes through the
      // user's current subdomain, where Russian-DL decides whether to record it. The page
      // is only shown to Russian-session users (in Russia, or declared citizens abroad).
      await maybeLogToRussia({ payload })
      await handleChangeJurisdictions(payload)
      return jurisdictions?.find((x) => x.jurisdiction === 'RUSSIA')?.doesApply ?? null
    },
    [handleChangeJurisdictions, jurisdictions]
  )
}

export async function maybeLogToRussia({ payload }) {
  try {
    await axios.post('/identity/register-api/ru-citizen', payload)
  } catch (error) {
    // do nothing
  }
}
